
import { EventBus } from "@/plugins/eventBus";
import Vue from "vue"

interface City {
  name: string,
  postcode: string
}

export default Vue.extend({
  name: "FilterCityList",
  data() {
    return {
      selectedCity: null as City | null,
      loading: false,
      cities: [] as City[],
      searchInput: null as string | null,
      debounceTimeout: null as number | null,
    }
  },
  watch: {
    selectedCity(newVal: City | null) {
      this.$emit('selectedCity', newVal)
    },
    searchInput(newVal: string | null) {
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout)
        this.debounceTimeout = null
      }
      if (!newVal) {
        this.cities = []
        this.loading = false
        return
      }
      this.debounceTimeout = globalThis.setTimeout(() => {
        this.getCities(newVal)
      }, 300)
    },
  },
  methods: {
    getItemText(item: City) {
      return `${item.name} (${item.postcode})`
    },
    filterCities(item: City, queryText: string, itemText: string) {
      const search = (queryText || "").toLowerCase()
      return (
        (itemText || "").toLowerCase().includes(search) ||
        (item.postcode || "").toLowerCase().includes(search)
      )
    },
    async getCities(query: string) {
      this.cities = []
      if (!query || query.length < 3) {
        this.loading = false
        return
      }
      this.loading = true
      try {
        const response = await fetch(
          `https://api-adresse.data.gouv.fr/search/?q=${encodeURIComponent(query)}`
        )
        if (response.ok) {
          const data = await response.json()
          if (data.features.length > 0) {
            this.cities = data.features.map((responseGouv: any) => {
              return {
                name: responseGouv.properties.city,
                postcode: responseGouv.properties.postcode,
              }
            })
          }
        }
      } catch {
        EventBus.$emit('snackbar',{message: this.$vuetify.lang.t('$vuetify.address_search_error'), color: 'error'})
      } finally {
        this.loading = false
      }
    },
  },
})
